import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import ButtonBar from "./ButtonBar";
import { useResponsiveFontSize } from "../functions";

const DreamSlider = ({
  images,
  buttons,
  gap,
  titleFontSize = "3rem",
  // textFontSize = "1rem",
  textLeft = "10%",
  textWidth = "80%",
  textAlign = "left",
  transform = "translate(0, -50%)",
}) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [animationStyle, setAnimationStyle] = useState({
    scale: 1,
    translateY: 0,
    opacity: 0,
  });

  const textFontSize = useResponsiveFontSize();

  useEffect(() => {
    let animationTimeout;

    const startAnimation = () => {
      // Reset immediately after the image changes
      setAnimationStyle({
        scale: 1,
        translateY: 0,
        opacity: 0,
      });

      // Apply animation with a slight delay to ensure the transition kicks in
      animationTimeout = setTimeout(() => {
        setAnimationStyle({
          scale: 1.15, // Slight zoom in
          translateY: 10, // Move image slightly upwards
          opacity: 1, // Fade in to fully visible
        });
      }, 500); // Delay before starting the animation
    };

    const fadeOutAnimation = () => {
      setAnimationStyle((prevStyle) => ({
        ...prevStyle,
        opacity: 0, // Fade out
      }));
    };

    const resetImage = () => {
      setAnimationStyle({
        scale: 1,
        translateY: 0,
        opacity: 0,
      });
    };
    const changeImage = () => {
      fadeOutAnimation(); // Fade out current image
      resetImage();

      setTimeout(() => {
        // Switch to the next image
        setCurrentImage((prevImage) => (prevImage + 1) % images.length);
        startAnimation(); // Start animation for the new image
      }, 2000); // Fade-out duration
    };

    const interval = setInterval(changeImage, 10000); // Change every 10 seconds

    // Start the first animation immediately
    startAnimation();

    return () => {
      clearInterval(interval);
      clearTimeout(animationTimeout);
    };
  }, [currentImage, images.length]);

  return (
    <Box
      sx={{
        display: "grid",
        background: `radial-gradient(circle at right,
          rgba(0, 0, 0, 0.9) 25%,
          rgba(0, 0, 0, 1) 50%,
          rgba(0, 0, 0, 1) 100%)`,
        width: "100vw",
        height: "70vh",
        color: "white",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Left Section with Text */}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: textLeft,
          width: textWidth,
          zIndex: 1,
          transform: transform,
          maxHeight: "50%",
        }}
      >
        <h1 style={{ fontSize: titleFontSize, margin: 0, fontWeight: "200" }}>
          We Interpret Dreams...
        </h1>
        <p
          style={{
            fontSize: textFontSize,
            marginTop: "1rem",
            fontWeight: "100",
            textAlign: textAlign,
            lineHeight: "1.25rem",
          }}
        >
          We provide end-to-end business advisory and management support
          services; creating alignment between dreams and reality.
        </p>
        <ButtonBar buttons={buttons} fontSize={textFontSize} gap={gap} />
      </Box>

      {/* Right Section with Changing Image */}
      <Box
        sx={{
          height: "100%",
          position: "absolute",
          right: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <img
          src={images[currentImage]}
          alt="dream interpretation"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "grayscale(85%) blur(0.5px) contrast(110%)", // Black and white with slight blur and contrast
            transform: `scale(${animationStyle.scale}) translateY(${animationStyle.translateY}px)`,
            opacity: animationStyle.opacity, // Apply opacity for fade-in and fade-out effect
            transition: `
              transform 3s ease-in-out, 
              opacity 2s ease-in-out`, // Separate timings for transform and opacity
          }}
        />
      </Box>
    </Box>
  );
};

export default DreamSlider;
